import { Card, CardBody, Col, Row } from "reactstrap";
import Image from "../Media";
import H4 from "../Headings/H4Element";
import H6 from "../Headings/H6Element";
import { useLocation } from "react-router-dom";
import IconComponent from "../IconComponent";
import SkeletonLoader from "../Loader/SkeletonLoader";

type InfoProps = {
  iconClassname?: string;
  image?: string;
  alt?: string;
  value?: number;
  label: string;
  loading?: boolean;
};

const InfoCard = ({
  image,
  alt,
  value,
  label,
  iconClassname,
  loading,
}: InfoProps) => {
  const location = useLocation();
  return (
    <Col xs="6" md="3" xl="3">
      <Card
        className={`${loading ? "" : "total-sales"} mt-xl-${
          location.pathname.includes("/user-management/user") ? "0" : "4"
        }`}
      >
        <CardBody>
          <Row className="justify-content-center">
            <Col md="8" sm="12" className="xl-12 col box-col-12">
              <div className="d-flex flex-column flex-xl-row align-items-center">
                {image && (
                  <div>
                    <Image
                      width={25}
                      height={25}
                      src={image}
                      alt={alt || "image"}
                    />
                  </div>
                )}
                {iconClassname && <IconComponent className={iconClassname} />}
                <section className="" style={{ width: "60%" }}>
                  <H4 className="text-center text-xl-start mb-1 ms-0 ms-lg-4 mt-2 mt-xl-0 f-16">
                    {loading ? <SkeletonLoader /> : value}
                  </H4>
                  <H6 className="text-capitalize text-center text-xl-start ms-0 ms-lg-4 f-14">
                    {loading ? <SkeletonLoader /> : label}
                  </H6>
                </section>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default InfoCard;
